<!-- Component for displaying the Sepio Guard API warning modal -->
<template>
	<PrecoaModal
		v-if="useAuthStore().missingSepioGuardApiProducerNumber()"
		:open="modelValue"
		@update:open="(value) => emit('update:modelValue', value ?? false)"
		class="sm:w-auto! md:max-w-md"
	>
		<template #default>
			<div class="flex flex-col items-center text-center">
				<ExclamationTriangleIcon class="mb-3 h-10 w-10 text-yellow-400" />

				<i18n-t
					keypath="auth.sepioProducerWarningModalTitle"
					tag="p"
					class="mb-3 text-base font-bold whitespace-pre-line text-slate-900"
				>
				</i18n-t>

				<i18n-t
					keypath="auth.sepioProducerWarningModalMessage"
					tag="p"
					class="mb-3 text-sm text-slate-500"
				>
					<strong>{{ t('auth.sepioProducerWarningAction') }}</strong>
				</i18n-t>
			</div>
		</template>

		<template #buttons>
			<div class="flex w-full flex-col gap-y-2">
				<RegularButton
					@click="emit('update:modelValue', false)"
					class="bg-accent-400 text-accent-700 border-accent-400 hover:bg-accent-500 w-full justify-center rounded-md border px-5 py-2 font-bold hover:text-white"
				>
					{{ t('auth.sepioProducerWarningCloseButton') }}
				</RegularButton>
			</div>
		</template>
		<template #footer>
			<i18n-t
				keypath="auth.sepioProducerWarningFooterMessage"
				tag="p"
				class="mb-6 text-center text-xs text-slate-500"
			>
				<a
					class="underline"
					href="mailto:salesstudio@precoa.com"
				>
					salesstudio@precoa.com
				</a>
			</i18n-t>
		</template>
	</PrecoaModal>
</template>

<script setup lang="ts">
import PrecoaModal from '@/components/common/PrecoaModal.vue'
import RegularButton from '@/components/forms/RegularButton.vue'
import { useAuthStore } from '@/stores/auth'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
	modelValue: boolean
}>()

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void
}>()
</script>
